import { HeroSection } from "../sections/hero"
import { useState } from "react"
import { Analytics } from "../components"


export const Home = () => {

    
    const [analysis, setAnalysis] = useState()


    return (
        <>
            {analysis 
                        ?   <Analytics analysis={analysis} setAnalysis={setAnalysis} />
                        :   <HeroSection setAnalysis={setAnalysis} />
            }
        </>
    )
}